import { URL_OVERRIDES } from './constants';
export function verticalsPlugin() {
  return function (router, options) {
    const cleanup = router.stateRegistry.decorator('url', urlDecorator);
    router.stateRegistry.register({
      url: '/',
      name: 'home'
    });
    router.stateRegistry.register({
      name: 'tpa',
      url: URL_OVERRIDES,
      params: {
        disableScrollToTop: {
          dynamic: true,
          type: 'bool',
          value: false,
          squash: true
        }
      }
    });
    return {
      name: 'WixUIRouterVerticalsBaseUrls',
      dispose() {
        cleanup();
      }
    };
    function urlDecorator(state, builder) {
      const baseUrl = options.baseUrls[state.name];
      if (baseUrl) {
        state.self.url = baseUrl + (state.self.url || '');
      }
      return builder(state);
    }
  };
}
//# sourceMappingURL=plugin.js.map